<template>
  <div class="merchant-row">
    <el-row class="merchant-name-row">
      <el-col :span="12" class="merchant-checked">
        <div
          v-if="userCartItem.signed"
          class="checked"
          @click="handleClickMerItem(userCartItem)"
        >
          <i class="el-icon-check"></i>
        </div>
        <div v-else @click="handleClickMerItem(userCartItem)">
          <i class="not-check"></i>
        </div>
        <div class="icon-name">
          <i class="icon iconfont">&#xe651;</i>
          <!-- TODO:购物车仓库字段 -->
          <span v-if="userCartItem.merchantCode === 'PATTERN'">{{ userCartItem.merchantName }}</span>
          <span v-else>{{ userCartItem.merchantName }}</span>
        </div>
      </el-col>
      <!-- <el-col v-if="userCartItem.isFreeShip" :span="12" align="right"> -->
      <el-col :span="12" align="right">
        <div>
          <!-- TODO: 运费计重，添加需支付运费 -->
          <div
            v-if="userCartItem.showType === 1"
            class="ship-info"
          >
            <span>{{TLang('已免运费','orderConfirm')}}</span>
          </div>
          <div
            v-else-if="userCartItem.showType === 3"
            class="ship-info"
            :style="{height: 'auto'}"
          >
            <el-tooltip
              :content="ReplaceText('X', userCartItem.freeWeight || '', TLang('重量超过要运费', 'address'))"
              placement="bottom-end"
            >
              <span :style="{ height: '30px'}">
                <span>{{TLang('需支付运费','my')}}</span>
                <img src="@assets/images/tips_bg.png" width="16px" />
              </span>
            </el-tooltip>
          </div>
          <div
            v-else-if="userCartItem.showType === 5"
            class="ship-info"
            :style="{height: 'auto'}"
          >
            <el-tooltip
              :content="TLang('该商家已开通自定义运费服务', 'orderConfirm')"
              placement="bottom-end"
            >
              <span :style="{ height: '30px'}">
                <span>{{ TLang('运费','orderConfirm') }}</span>
                <img src="@assets/images/tips_bg.png" width="16px" />
              </span>
            </el-tooltip>
          </div>
          <div
            v-else-if="userCartItem.showType === 2"
            class="ship-info"
          >
            <!-- <span style="margin-right:8px;">
              <img src="@assets/images/icon_baoYou.png" alt="" width="34"/>
            </span> -->
            <div v-if="userCartItem.differAmount !== 0" class="flex">
              <div>
                <el-tooltip
                  :content="TLang('运费最终运费以填写订单页为准','address')"
                  placement="bottom-end"
                >
                  <span class="freightRuleTip">
                    {{ ReplaceText(
                      'XX',
                      parseFloat(
                        (userCartItem.freeShipPrice * union_scale)
                      ).toFixed(2),
                      ReplaceText(
                        'YY',
                        parseFloat(
                          ((userCartItem.differAmount || 0) * union_scale)
                        ).toFixed(2),
                        ReplaceText(
                          'UU',
                          union_name || TLang('福豆','card'),
                          TLang('满x包邮差y包邮', 'list'),
                          true,
                        )
                      )
                    ) }}
                  </span>
                </el-tooltip>
              </div>
              <h6 @click="toAddList(userCartItem)">
                <i>{{ TLang('去凑单','list') }}</i>
              </h6>
            </div>
          </div>
          <div
            v-else
            class="ship-info"
          >
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="goods-wrap">
      <div
        v-for="goods in userCartItem.merchantGoods"
        :key="goods.id"
        :class="{ 'item-wrap': true, manJian: goods.fullReductionInfo }"
      >
        <GoodsItem
          v-if="goods.id"
          :goods="goods"
          :onCheckoutSpec="updateSpecGoods"
          :onUpdateCount="handleStepperChange"
          :onSignChange="onSignChange"
          :onDelGoods="handleDelGoods"
          :isBFD="isBFD"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GoodsItem from "./goodsItem";
import { gioClickHandle } from "@utils";
export default {
  components: { GoodsItem },
  props: {
    userCartItem: {
      type: Object,
      default: function() {
        return {};
      },
    },

    handleClickMerItem: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    onSignChange: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    handleCheckoutSpec: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    handleUpdateGoodsNum: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    handleDelGoods: Function,
    isBFD: Boolean,
  },
  data() {
    console.log('userCartItem', this.userCartItem);
    return {
      popVisible: false,
      deletePopVisible: false,
    };
  },
  methods: {
    updateSpecGoods(newGoods, oldGoods) {
      this.popVisible = false;
      this.handleCheckoutSpec(newGoods, oldGoods);
    },
    handleStepperChange(goods, val) {
      this.handleUpdateGoodsNum(val, goods);
    },
    onClickDel(goods) {
      this.deletePopVisible = true;
      this.handleDelGoods(goods);
    },
    toAddList(userCartItem) {
      this.changeGio("包邮凑单", "去凑单");
      window.localStorage.removeItem("categoryIdList");
      // console.log(userCartItem);
      let categoryIdList = [];
      userCartItem.merchantGoods.forEach((element) => {
        if (element.signed === 1) {
          categoryIdList.push(element.categoryId);
        }
      });
      window.localStorage.setItem(
        "categoryIdList",
        JSON.stringify(categoryIdList)
      );
      // 已经修改打开新窗口
      setTimeout(() => {
        // console.log('userCartItem', userCartItem)
        const priceItem = userCartItem.differAmount ? `price=${ parseFloat(((userCartItem.differAmount || 0) * union_scale)).toFixed(2)}&` : '';
        const mid = userCartItem.merchantId ? `mId=${userCartItem.merchantId}&` : 'mId=&';
        const channelId = userCartItem.channelId ? `channelId=${userCartItem.channelId}&` : '';
        const merchantType = userCartItem.type ? `merchantType=${userCartItem.type}&` : '';
        // window.location.href = `/shop/add/list?${mid}${channelId}`;
        window.open(`/shop/add/list?${priceItem}${mid}${channelId}${merchantType}`,this.isFeishuOrDingding ? '_self' : '_blank')
      }, 300);
    },
    changeGio(df_modulename, df_elementname) {
      try {
        let channel = "";
        const params = {
          df_channle: channel,
          df_modulename: df_modulename,
          df_elementname: df_elementname,
        };
        gioClickHandle("DF_elementClick", params, "cart");
      } catch (e) {
        console.log("埋点失败:", e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.merchant-row {
  .merchant-name-row {
    line-height: 49px;
    .merchant-checked {
      display: flex;
      align-items: center;
      .icon-name {
        margin-left: 12px;
        i {
          color: #ccc;
        }
      }
    }
    .ship-info {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 50px;
      div {
        font-size: 12px;
        color: rgba(51, 51, 51, 1);
      }
      h6 {
        margin-left: 24px;
        font-size: 12px;
        color: #ffaf00;
        height: 50px;
        display: flex;
        align-items: center;
        i {
          line-height: 49px;
          padding-right: 12px;
          background: url("../../../assets/images/baoYouRight.png") right center
            no-repeat;
          background-size: auto 12px;
        }
        &:hover {
          cursor: pointer;
        }
      }
      .freightRuleTip {
        cursor: pointer;
        padding-right: 16px;
        background: url("../../../assets/images/order/freightRule.png") right center
            no-repeat;
        background-size: auto 13.33px;    
      }
    }
  }
  .goods-wrap {
    border: 1px solid rgba(229, 229, 229, 1);
    .item-wrap {
      // padding: 0 10px;
      border-bottom: 1px solid #f0f0f0;
    }
    .manJian {
      border-bottom: none;
      &:last-child {
        border-bottom: 1px solid #f0f0f0;
      }
    }
  }
}
</style>
